var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 9C5.11929 9 4 10.1193 4 11.5C4 12.8807 5.11929 14 6.5 14C7.88071 14 9 12.8807 9 11.5C9 10.1193 7.88071 9 6.5 9ZM2 11.5C2 9.01472 4.01472 7 6.5 7C8.15819 7 9.60689 7.89687 10.3875 9.23198C10.8019 9.10302 11.3403 9 12 9C12.6597 9 13.1981 9.10302 13.6125 9.23198C14.3931 7.89687 15.8418 7 17.5 7C19.9853 7 22 9.01472 22 11.5C22 13.9853 19.9853 16 17.5 16C15.0147 16 13 13.9853 13 11.5C13 11.379 13.0048 11.259 13.0142 11.1404C12.7813 11.0683 12.4441 11 12 11C11.5559 11 11.2187 11.0683 10.9858 11.1404C10.9952 11.259 11 11.379 11 11.5C11 13.9853 8.98528 16 6.5 16C4.01472 16 2 13.9853 2 11.5ZM17.5 9C16.1193 9 15 10.1193 15 11.5C15 12.8807 16.1193 14 17.5 14C18.8807 14 20 12.8807 20 11.5C20 10.1193 18.8807 9 17.5 9Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogles);
export default __webpack_public_path__ + "static/media/googles.17fcafd84944caa9a6078b1aa40f22b3.svg";
export { ForwardRef as ReactComponent };